const ReimbursementDetailsModel = class {
  carrotCardCardId: any
  carrotCardProvider: any
  deductible: any
  insuranceSync: any
  subsidy: any
  constructor(
    // @ts-expect-error TS(7006) FIXME: Parameter 'insuranceSync' implicitly has an 'any' ... Remove this comment to see the full error message
    insuranceSync = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'subsidy' implicitly has an 'any' type.
    subsidy = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'deductible' implicitly has an 'any' typ... Remove this comment to see the full error message
    deductible = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'carrotCardProvider' implicitly has an '... Remove this comment to see the full error message
    carrotCardProvider = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'carrotCardCardId' implicitly has an 'an... Remove this comment to see the full error message
    carrotCardCardId = null
  ) {
    this.insuranceSync = insuranceSync
    this.subsidy = subsidy
    this.deductible = deductible
    this.carrotCardProvider = carrotCardProvider
    this.carrotCardCardId = carrotCardCardId
  }
}

const MerchantValidModel = class {
  companyAmount: any
  companyCurrencyCode: any
  isApproved: any
  merchantAmount: any
  merchantCurrencyCode: any
  merchantName: any
  constructor(
    // @ts-expect-error TS(7006) FIXME: Parameter 'isApproved' implicitly has an 'any' typ... Remove this comment to see the full error message
    isApproved = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'companyAmount' implicitly has an 'any' ... Remove this comment to see the full error message
    companyAmount = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'companyCurrencyCode' implicitly has an ... Remove this comment to see the full error message
    companyCurrencyCode = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'merchantAmount' implicitly has an 'any'... Remove this comment to see the full error message
    merchantAmount = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'merchantCurrencyCode' implicitly has an... Remove this comment to see the full error message
    merchantCurrencyCode = null,
    // @ts-expect-error TS(7006) FIXME: Parameter 'merchantName' implicitly has an 'any' t... Remove this comment to see the full error message
    merchantName = null
  ) {
    this.isApproved = isApproved
    this.companyAmount = companyAmount
    this.companyCurrencyCode = companyCurrencyCode
    this.merchantAmount = merchantAmount
    this.merchantCurrencyCode = merchantCurrencyCode
    this.merchantName = merchantName
  }
}

export { MerchantValidModel, ReimbursementDetailsModel }
